import {AgencyRepository} from "../../../repositories/AgencyRepository.ts";
import {Agency} from "../../entities/Agency.ts";

export class GetAgencyByIdUseCase {
    constructor(private readonly agencyRepository: AgencyRepository) {}

    execute(agencyId: string): Promise<Agency> {
        return this.agencyRepository.getAgencyById(agencyId)
    }
}
